import { render, staticRenderFns } from "./sage-integration.vue?vue&type=template&id=1c7ceeec&scoped=true&"
import script from "./sage-integration.vue?vue&type=script&lang=js&"
export * from "./sage-integration.vue?vue&type=script&lang=js&"
import style0 from "./sage-integration.vue?vue&type=style&index=0&id=1c7ceeec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7ceeec",
  null
  
)

export default component.exports